import { createAction, props } from '@ngrx/store';
import {
  DocScanWebServiceResult,
  DocScanWebComponentResult,
  DocumentScanningStatus,
} from "../models/document-scanning.models";

export const scanDocumentUsingWebService = createAction(
  '[API] Scan document using web service',
  props<{formTemplateCode: string, docScanWebComponentResult: DocScanWebComponentResult, isBackoffice: boolean}>()
);

export const scanDocumentUsingWebServiceSuccess = createAction(
  '[API] Scan document using web service success',
  props<{data: DocScanWebServiceResult[]}>()
);

export const scanDocumentUsingWebServiceError = createAction(
  '[API] Scan document using web service error',
  props<{errors: string[]}>()
);

export const scanningDocument = createAction(
  '[Form] Scanning document',
  props<{status: DocumentScanningStatus}>()
);

export const getShortUrl = createAction(
  '[API] Get Short Url',
  props<{longUrl: string}>()
);

export const getShortUrlSuccess = createAction(
  '[API] Get Short Url Success',
  props<{shortUrl: string}>()
);

export const getShortUrlFailure = createAction(
  '[API] Get Short Url Failure',
  props<{error: string}>()
);

export const skipDocumentScanning = createAction(
  '[Form] Skip document scanning'
);

export const resetSkipDocumentScanning = createAction(
  '[Form] Reset skip document scanning'
);

export const createUid = createAction('[User] create uid');
export const createUidSuccess = createAction(
  '[User] create uid success',
  props<{ uid: string }>()
);

export const resetAutoFillForm = createAction('[Forms] Reset AutoFill form');

